import { render, staticRenderFns } from "./saleGoodsDetail.vue?vue&type=template&id=efaea932&scoped=true&"
import script from "./saleGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./saleGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleGoodsDetail.vue?vue&type=style&index=0&id=efaea932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaea932",
  null
  
)

export default component.exports